import { Button, Typography } from "antd";
import { SvgIcon } from "assets/icons";
import CustomModal from "components/CustomModal";
import { useConfirmDepositPurchaseOrder } from "hooks/purchase";
import { t } from "i18next";
import { useState } from "react";
import { notify } from "utils/helperFuncs";
import "./index.scss";

export const ButtonConfirmDeposit = ({ record }) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const { handleConfirmDepositPurchaseOrder, loading } = useConfirmDepositPurchaseOrder();

  const onConfirm = async () => {
    try {
      await handleConfirmDepositPurchaseOrder([record?.id])
        .then(() => {
          setVisible(false);
          notify.success({
            message: t("purchase.buttonGroup.confirmDepositMessageSuccess"),
          });
        })
        .catch((error) => {
          notify.error({
            message: error.message,
          });
        });
    } catch (error) {
      notify.error({
        message: error.message,
      });
    }
  };

  return (
    <div>
      <CustomModal
        {...{
          width: "35%",
          customComponent: (
            <Button type="primary" loading={loading}>
              {t("purchase.buttonGroup.confirmDeposit")}
            </Button>
          ),
          footer: false,
          centered: true,
          styleButton: "notButton",
          hideConfirmButton: true,
          className: "form-confirm-deposit-purchase-order",
          addMoreButton: (
            <div className="button-group-action-confirm-deposit-purchase-order">
              <Button type="secondary" htmlType="submit" onClick={handleCancel} loading={loading}>
                {t("productBrand.cancel")}
              </Button>
              <Button type="primary" htmlType="submit" onClick={onConfirm} loading={loading}>
                {t("common.confirm")}
              </Button>
            </div>
          ),
          visible: visible,
          onOpen: showModal,
          onCancel: handleCancel,
          hideCancelButton: true,
          loading: loading,
        }}
      >
        <div className="form-confirm-deposit-content">
          <SvgIcon.IconInfoConfirm />
          <div>
            <Typography.Text>{t("purchase.buttonGroup.confirmDepositMessage")} </Typography.Text>
            <Typography.Link strong>{record?.code}</Typography.Link>?
          </div>
        </div>
      </CustomModal>
    </div>
  );
};
